module.exports = __webpack_public_path__ + "img/MTABSYSW.9df91edf.jpg";